<script setup lang="ts"></script>

<template>
  <div class="dropdown">
    <slot name="icon"></slot>
    <ul id="dropdown" class="dropdown-menu dropdown-menu-end">
      <slot name="content" class="content"></slot>
    </ul>
  </div>
</template>

<style scoped>
h4 {
  text-align: center;
}

#dropdown {
  z-index: calc(var(--z-index-app-navbar) + 1);
}
</style>
